/**
 * BankIcon
 *
 * Bank / ACH instrument icon, sized to match CardBrandIcon (24×16) so it drops into
 * the same logo slot for a bank payment method.
 */

import type { SVGProps } from 'react'

export function BankIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="16"
      viewBox="0 0 24 16"
      fill="none"
      aria-label="Bank account"
      className={className}
      {...props}
    >
      <rect x="0.25" y="0.25" width="23.5" height="15.5" rx="1.75" fill="#EAF2FF" stroke="#C7D9F5" strokeWidth="0.5" />
      <path d="M12 3L18.5 6.2H5.5L12 3Z" fill="#2563EB" />
      <rect x="6.4" y="7" width="1.5" height="4.2" fill="#2563EB" />
      <rect x="11.25" y="7" width="1.5" height="4.2" fill="#2563EB" />
      <rect x="16.1" y="7" width="1.5" height="4.2" fill="#2563EB" />
      <rect x="5" y="12" width="14" height="1.4" rx="0.4" fill="#2563EB" />
    </svg>
  )
}
